/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplatesControllerCreateMutationRequest, TemplatesControllerCreateMutationResponse, TemplatesControllerCreate400, TemplatesControllerCreate401, TemplatesControllerCreate403 } from "../../models/checklistsController/TemplatesControllerCreate";

function getTemplatesControllerCreateUrl() {
  const res = { method: 'POST', url: `/api/v1/checklist-templates` as const }  
  return res
}

/**
 * @summary Create a new checklist template
 * {@link /api/v1/checklist-templates}
 */
export async function templatesControllerCreate(data?: TemplatesControllerCreateMutationRequest, config: Partial<RequestConfig<TemplatesControllerCreateMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<TemplatesControllerCreateMutationResponse, ResponseErrorConfig<TemplatesControllerCreate400 | TemplatesControllerCreate401 | TemplatesControllerCreate403>, TemplatesControllerCreateMutationRequest>({ method : "POST", url : getTemplatesControllerCreateUrl().url.toString(), data : requestData, ... requestConfig, headers : { 'Content-Type': 'application/vnd.api+json', ...requestConfig.headers } })  
  return res.data
}